var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',_vm._b({on:{"click":_vm.handleTest}},'a-button',_vm.config,false),[_vm._v(_vm._s(_vm.$t('common_269')))])}
var staticRenderFns = []

export { render, staticRenderFns }